const AUTH_PUBLIC_ROUTES = new Set(['onboarding', 'onboardingIntro', 'password-recovery', 'presentPartageClub']);

const GUEST_BROWSING_ROUTES = new Set(['all-listings', 'one-listing', 'grouped-listing', 'help']);

// These paths are visible while nested navigators are mounting. Redirecting from
// them can race with React Navigation's state hydration and repeatedly target the
// URL that is already loading.
const TRANSITIONAL_ROUTES = new Set(['splash', 'main', 'main/billboard']);

export type UnauthenticatedWebRedirect = 'guest-billboard' | 'onboarding';

export function getUnauthenticatedWebRedirect(
  routePath: string | undefined,
  guestAccessEnabled: boolean,
): UnauthenticatedWebRedirect | undefined {
  if (!routePath || TRANSITIONAL_ROUTES.has(routePath)) return undefined;

  const routeNames = routePath.split('/');
  if (routeNames.some((routeName) => AUTH_PUBLIC_ROUTES.has(routeName))) return undefined;

  if (guestAccessEnabled && routeNames.some((routeName) => GUEST_BROWSING_ROUTES.has(routeName))) {
    return undefined;
  }

  return guestAccessEnabled ? 'guest-billboard' : 'onboarding';
}
